import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ThemeProvider } from './shared/context';
import { QueryProvider } from './shared/providers/QueryProvider';
import { SessionExpiredDialog } from './features/auth';
import { router } from './app/router';
import { initAnalytics } from './lib/analytics';

// Initialise Amplitude once, client-side only, before the app renders.
initAnalytics();

const App: React.FC = () => (
  <QueryProvider>
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <RouterProvider router={router} />
      </LocalizationProvider>
      <SessionExpiredDialog />
    </ThemeProvider>
  </QueryProvider>
);

export default App;
